import { mapGetters } from 'vuex';

export default {
  components: {
  },
  props: ['type'],
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
    ...mapGetters([
      'getTenantParams'
    ])
  },
  methods: {
  }
};
